import { IconWrapper } from '../runtime';
export default IconWrapper('members-docer-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.1781 12.6749C14.7327 12.3764 15.1111 11.7829 15.1111 11.0987V4.89821C15.1111 4.29308 14.8148 3.75908 14.3626 3.42792L9.05044 0.360646C8.75801 0.135279 8.39491 0 8.00003 0C7.60514 0 7.24204 0.135279 6.91159 0.360646L1.89855 3.28834C1.36304 3.54334 0.975701 4.06594 0.891819 4.6884L0.888916 11.0966C0.888916 11.8563 1.35564 12.503 2.01175 12.7846L6.94424 15.6352C7.23769 15.8631 7.60268 16 8.00003 16C8.39738 16 8.76237 15.8631 9.08919 15.6352L14.1781 12.6749Z",
      "fill": "#F05B13"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.5715 7.66185C11.3392 8.7237 10.8065 9.72761 9.97845 10.5267C9.0957 11.3785 8.01204 11.8676 6.8993 12C7.13143 10.938 7.66416 9.93408 8.4923 9.135C9.36854 8.28946 10.4428 7.80131 11.5469 7.66465L11.5715 7.66185ZM5.77878 5.65448C5.76798 5.80626 5.76256 5.95949 5.76256 6.11399C5.76256 7.18692 6.02381 8.19772 6.48506 9.08408L6.4876 9.08963C6.66983 9.44236 6.77296 9.84424 6.77296 10.2707C6.77296 10.9389 6.51969 11.5468 6.10582 11.9998C5.12934 11.2362 4.5 10.0354 4.5 8.68494C4.5 7.49193 4.99114 6.41574 5.77878 5.65448ZM8.7561 3C9.17779 4.05159 9.29734 5.24426 9.03003 6.43808C8.76201 7.63489 8.14505 8.65494 7.31565 9.41008C6.89377 8.35845 6.77422 7.16575 7.04154 5.97194C7.30784 4.78292 7.91851 3.76836 8.73971 3.01474L8.7561 3Z",
      "fill": "white"
    }
  })]);
});